/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Items are matched exactly, so “Apple” and “apple” count as different. Duplicate items within one set are counted once.`)
};

const es_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Los elementos se comparan de forma exacta, así que “Manzana” y “manzana” cuentan como diferentes. Los elementos duplicados dentro de un conjunto se cuentan una vez.`)
};

const de_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elemente werden exakt verglichen, sodass „Apple“ und „apple“ als unterschiedlich zählen. Doppelte Elemente innerhalb einer Menge werden einmal gezählt.`)
};

const nl_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Items worden exact vergeleken, dus "Apple" en "apple" tellen als verschillend. Dubbele items binnen één set worden één keer geteld.`)
};

const fr_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les éléments sont comparés exactement, donc « Pomme » et « pomme » comptent comme différents. Les éléments en double au sein d'un même ensemble ne sont comptés qu'une seule fois.`)
};

const it_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Gli elementi vengono confrontati esattamente, quindi "Mela" e "mela" contano come diversi. Gli elementi duplicati all'interno di un insieme vengono contati una volta sola.`)
};

const pt_br2_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os itens são comparados exatamente, então "Maçã" e "maçã" contam como diferentes. Itens duplicados dentro de um conjunto são contados uma vez.`)
};

const pt_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os itens são comparados de forma exata, pelo que “Maçã” e “maçã” contam como diferentes. Os itens duplicados dentro de um mesmo conjunto são contados uma única vez.`)
};

const ja_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。項目は完全一致で照合されるため、「Apple」と「apple」は別の項目としてカウントされます。1つの集合内の重複項目は1回のみカウントされます。`)
};

const zh_venn_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。项目会进行精确匹配，因此“Apple”和“apple”会被视为不同项目。同一集合内的重复项目只计算一次。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const venn_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.venn_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("venn_faq_a4", locale)
	if (locale === "en") return en_venn_faq_a4(inputs)
	if (locale === "es") return es_venn_faq_a4(inputs)
	if (locale === "de") return de_venn_faq_a4(inputs)
	if (locale === "nl") return nl_venn_faq_a4(inputs)
	if (locale === "fr") return fr_venn_faq_a4(inputs)
	if (locale === "it") return it_venn_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_venn_faq_a4(inputs)
	if (locale === "pt") return pt_venn_faq_a4(inputs)
	if (locale === "ja") return ja_venn_faq_a4(inputs)
	return zh_venn_faq_a4(inputs)
};